<template>
  <v-dialog width="800px" v-model="show" @click:outside="$store.commit('close_edit_news_dialog')">
    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>
          ویرایش خبر
        </v-card-title>
        <v-card-text>
          <fieldset style="border: none!important;">
            <v-row class="pa-2">
              <v-col cols="12">
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                >
                  <v-select
                      :items="categories"
                      label="بخش"
                      v-model="edit_value.category"
                      :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="4">
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                >
                  <v-select
                      :items="days"
                      label="روز"
                      v-model="edit_value.day"
                      :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="4">
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                >
                  <v-select
                      :error-messages="errors"
                      item-value="value"
                      item-text="text"
                      v-model="edit_value.month"
                      :items="months"
                      label="ماه"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="4">
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                >
                  <v-select
                      :error-messages="errors"
                      label="سال"
                      :items="years"
                      v-model="edit_value.year"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </fieldset>

          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-text-field v-model="edit_value.title" :error-messages="errors" color="accent" label="عنوان خبر"
                          outlined>
            </v-text-field>
          </validation-provider>


          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-textarea v-model="edit_value.description" :error-messages="errors" color="accent" outlined
                        label="خلاصه خبر" rows="3" required>
            </v-textarea>
          </validation-provider>

          <div class="my-3 text-start">
            متن خبر
            <vue-editor class="mt-1" v-model="edit_value.content"></vue-editor>
          </div>


        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$store.commit('close_edit_news_dialog')">
            لغو
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="invalid"
                 @click="$store.dispatch('edit_news',{edit_picture:false,  values: edit_value})">
            ویرایش
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>

</template>

<script>
import {mapState} from "vuex";
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";
import static_config from "@/components/common/Statics";
import {VueEditor} from "vue2-editor";

export default {
  name: "EditNewsDialog",
  data: () => {
    return {
      value: null,
      months: static_config.months,
      categories: static_config.new_categories
    }

  },
  computed: {
    ...mapState({
      show: state => state.Admin.settings.edit_news_dialog.show,
      edit_value: state => state.Admin.settings.edit_news_dialog.news,
    }),
    years: () => {
      let y = [];
      for (let i = 1401; i >= 1398; i--) {
        y.push(i);
      }
      return y;
    },
    days: () => {
      let y = [];
      for (let i = 1; i <= 30; i++) {
        y.push(i);
      }
      return y;
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    VueEditor,
  }
}
</script>

<style scoped>

</style>